<template>
    <div>
        <section class="section has-bottom-image">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div v-if="valid">
                            <img
                                class="text-center col-4 offset-4"
                                src="./../assets/images/signed.svg"
                            />
                            <h1 class="text-center">{{ $t('account.complete.title') }}</h1>
                            <p class="text-center">
                                {{ $t('account.complete.sub_title') }}
                            </p>
                            <div class="row">
                                <a
                                    class="button--secondary button--rounded col-12 col-sm-5"
                                    href="https://www.tecnotion.com/"
                                >
                                    {{ $t('account.buttons.homepage') }}
                                </a>
                                <router-link
                                    class="button--primary button--rounded col-12 col-sm-5 push-sm-2"
                                    :to="{ name: 'Dashboard' }"
                                    @click.native="registerLogin()"
                                >
                                    {{ $t('account.buttons.simtool') }}
                                </router-link>
                            </div>
                        </div>
                        <div v-else>
                            <img
                                class="text-center col-4 offset-4"
                                src="./../assets/images/signed_error.svg"
                            />
                            <h1 class="text-center">{{ $t('account.complete.error_title') }}</h1>
                            <p class="text-center">
                                {{ $t('account.complete.error_text') }}
                            </p>
                            <div class="row">
                                <a
                                    class="button--secondary button--rounded col-12 col-sm-6 push-sm-3"
                                    href="https://www.tecnotion.com/"
                                >
                                    {{ $t('account.buttons.homepage') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img class="section__bottom_image" src="./../assets/images/tecnotion-blue.png" />
        </section>
        <EndSignUpMail id="endsignup" />
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import EndSignUpMail from '@/components/EndSignUpMail';

@Component({ components: { EndSignUpMail } })
export default class SignUpComplete extends Vue {
    valid = false;

    async created() {
        if (this.$route.query && this.$route.query.token && this.$route.query.email) {
            this.valid = await this.$store.dispatch('verifyEmail', this.$route.query);
        }
    }

    registerLogin() {
        const data = {
            email: JSON.parse(this.getCookie('tecnotion_user')).email,
        };
        data.hubspotutk = this.getCookie('hubspotutk');
        data.__hstc = this.getCookie('__hstc');
        data.__hssc = this.getCookie('__hssc');

        Vue.api.post('/register-login').send(JSON.stringify(data));
    }

    getCookie(name) {
        var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) return match[1];
        else return '';
    }
}
</script>
